import { render, staticRenderFns } from "./Paketlemeislemi.vue?vue&type=template&id=73dacbf2&scoped=true&"
import script from "./Paketlemeislemi.vue?vue&type=script&lang=js&"
export * from "./Paketlemeislemi.vue?vue&type=script&lang=js&"
import style0 from "./Paketlemeislemi.vue?vue&type=style&index=0&id=73dacbf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dacbf2",
  null
  
)

export default component.exports